import React from "react";
import { Card, Col, Row, Typography } from "antd";
import "./index.scss";
import { IHeadlinesSummary } from "../../../../interfaces/dashboard";
import { formatEuropeanCurrencyIntl, formatNumber } from "../../../../utils/helper";

const { Text, Title } = Typography;

interface HeadlinesSummaryProps {
  data: IHeadlinesSummary;
  loading: boolean;
  dataFilter: {
    supplierIds: number[] | null
  } | null
}

const HeadlinesSummary: React.FC<HeadlinesSummaryProps> = ({ data, loading, dataFilter }) => {
  return (
    <div className="headlines-summary">
      {/* Row 1: Overdue ESPs + Unmatched invoices */}
      <Row gutter={[16, 16]} className="headlines-summary__row">
        <Col xs={24} md={12}>
          <Card className="headlines-summary__card headlines-summary__card--overdue">
            <div className="headlines-summary__label">Overdue ESPs</div>
            <Title level={3} className="headlines-summary__value">
              {data.overdueEsps
                ? `£${formatEuropeanCurrencyIntl(data.overdueEsps)}`
                : "---"}
            </Title>
          </Card>
        </Col>

        <Col xs={24} md={12}>
          <Card className="headlines-summary__card headlines-summary__card--unmatched">
            <div className="headlines-summary__label">Unmatched invoices</div>
            <Title level={3} className="headlines-summary__value">
              {data.unmatchedInvoices
                ? `${formatNumber(data.unmatchedInvoices)}`
                : "---"}
            </Title>
          </Card>
        </Col>
      </Row>

      {/* Row 2: AP Owner + Product Owner */}
      {dataFilter?.supplierIds && dataFilter.supplierIds.length > 0 && (
        <Row gutter={[16, 16]} className="headlines-summary__row">
          <Col xs={24} md={12}>
            <Card className="headlines-summary__card headlines-summary__card--owner">
              <div className="headlines-summary__owner">
                AP Owner
                <Text className="headlines-summary__value">
                  {data.apOwner || "---"}
                </Text>
              </div>
            </Card>
          </Col>

          <Col xs={24} md={12}>
            <Card className="headlines-summary__card headlines-summary__card--owner">
              <div className="headlines-summary__owner">
                Product Owner
                <Text className="headlines-summary__value">
                  {data.productOwner || "---"}
                </Text>
              </div>
            </Card>
          </Col>
        </Row>
      )}
    </div>
  );
};

export default React.memo(HeadlinesSummary);
